<template>
<!-- eslint-disable max-len -->
<p class="narrator-notification" :style="style" :class="{ left, native: native, sf: starfighter }">
  <slot></slot>
</p>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    width: { type: String },
    left: { type: Boolean }
  },
  computed: {
    ...mapGetters([
      'game',
      'starfighter',
      'native'
    ]),
    style() {
      return {
        width: this.width || '425px'
      };
    }
  },
  methods: {
    navigate() {
      if (this.next) {
        this.next();
      } else if (this.to) {
        if (this.replace) this.$router.replace(this.to);
        else this.$router.push(this.to);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.narrator-notification {
  position: absolute;
  background-color: white;
  color: black;
  margin: 0;
  padding: 15px;
  font-size: 26px;
  // font-weight: bold;
  text-align: center;
}
.narrator-notification.sf {
  border-radius: 35px;
  border: 4px solid black;
}
.narrator-notification.native {
  border-radius: 10px;
}
.narrator-notification::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0px 0px 40px 32px;
  top: -41px;
  left: 170px;
}
.narrator-notification.sf::before {
  border-color: transparent transparent black transparent;
}
.narrator-notification.native::before {
  border-color: transparent transparent rgba(150, 150, 150, 0.35) transparent;
}
.narrator-notification.left::before {
  left: unset;
  right: 170px;
  border-width: 0px 32px 40px 0px;
}
.narrator-notification::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0px 0px 34px 27.2px;
  border-color: transparent transparent white transparent;
  top: -33px;
  left: 172px;
}
.narrator-notification.left::after {
  left: unset;
  right: 172px;
  border-width: 0px 27.2px 34px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/NarratorNotification.vue